import toaster from 'helpers/toaster';

let pendingMessage = null;
let isReady = false;

export const notifyWhenReady = message => {
  if (isReady) {
    toaster(message);
    return;
  }

  pendingMessage = message;
};

export const markNotificationsReady = () => {
  isReady = true;

  if (!pendingMessage) {
    return;
  }

  toaster(pendingMessage);
  pendingMessage = null;
};
